const pad = n => n < 10 ? '0' + n : n;

function formatTimestamp(timestamp) {
//  const unixTimestamp = new Date(timestamp * 1000);
  const unixTimestamp = new Date(timestamp);
  const year = unixTimestamp.getFullYear();
  const month = unixTimestamp.getMonth() + 1;
  const day = unixTimestamp.getDate();
  const hour = unixTimestamp.getHours();
  const min = unixTimestamp.getMinutes();
  const sec = unixTimestamp.getSeconds();

  return `${year}년${pad(month)}월${day}일  ${hour}시${min}분${pad(sec)}초`;
};

function toNativeFormat (data,index) {   
  var values = [];
  var keys = Object.keys(data[0]);
  var dtIndex = keys.findIndex(g => g === 'YMD');
  keys.splice(dtIndex,1);
  keys.splice(0,0,'YMD')

  data.forEach((v,idx) => {
    let item = [];
    for (var i=0; i < keys.length; i++) { 
        let objKey = keys[i]
        if( idx !== 0 && v[objKey] === "NaN") {
          item[i] = values[idx-1][i];
        } else {
          item[i] = Number(v[objKey]);
 //         item[i] = parseInt(v[objKey]);
        } 
    }
    values[idx] = new Array(keys.length);
    values[idx] = item;
  });

  var nativeFormat = 
      {
        index: index,
        labels: keys,
        values: values,
      };
  
  return nativeFormat;
}

export default {
  formatTimestamp,
  toNativeFormat,
}